var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delivery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(17.967516, 17.000000)",
    stroke: "#000000",
    strokeWidth: 2.56000004
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22.1713277,
    y1: 45.6011546,
    x2: 22.1713277,
    y2: 18.970755,
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3168445,45.2294234 L1.29175678,36.5374555 C0.507436794,36.1957595 0.000364799997,35.4235996 0.000364799997,34.5675356 L0.000364799997,10.7594719 C0.000364799997,9.90097588 0.509868794,9.12759989 1.29783678,8.78711989 L21.3229245,0.174191998 C21.8652605,-0.0580639993 22.4781245,-0.0580639993 23.0192445,0.174191998 L43.0455483,8.78711989 C43.8335162,9.12759989 44.3430202,9.90097588 44.3430202,10.7594719 L44.3430202,34.5675356 C44.3430202,35.4235996 43.8359482,36.1957595 43.0516283,36.5374555 L23.0265405,45.2294234 C22.4817725,45.4653274 21.8616125,45.4653274 21.3168445,45.2294234 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.34672308 L21.3189117,18.600483 C21.8624637,18.837603 22.4801917,18.837603 23.0249597,18.600483 L44.3426554,9.34672308",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.9347516,
    y1: 4.32719675,
    x2: 10.7634239,
    y2: 13.9518366,
    id: "Stroke-7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.3654bb063721aa22c5614add41d50670.svg";
export { ForwardRef as ReactComponent };